const isAlphaNumeric = (string: string): boolean => /^[a-z0-9]+$/i.test(string);
const isAlphaNumericIncludingSpaces = (string: string): boolean =>
  /^[a-z0-9 ]+$/i.test(string);

export { isAlphaNumeric, isAlphaNumericIncludingSpaces };
